import { ReactElement } from 'react';

import { TherapeuticGroupType } from '@dreryk/egabinet-group-session-frontend-api';

import { Text } from '@dreryk/react-components';
import { useTranslate } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

type TypeCellProps = {
   readonly type: TherapeuticGroupType;
};

export const TypeCell = (props: TypeCellProps): ReactElement => {
   const translate = useTranslate();

   return <Text testId={'type'}>{translate(translationKeys.groupSessionsTypeMap[props.type])}</Text>;
};
